import { render, staticRenderFns } from "./platPanelLogin.vue?vue&type=template&id=5fef7252&scoped=true"
import script from "./platPanelLogin.vue?vue&type=script&lang=js"
export * from "./platPanelLogin.vue?vue&type=script&lang=js"
import style0 from "./platPanelLogin.vue?vue&type=style&index=0&id=5fef7252&prod&lang=scss"
import style1 from "./platPanelLogin.vue?vue&type=style&index=1&id=5fef7252&prod&lang=scss&scoped=true"
import style2 from "./platPanelLogin.vue?vue&type=style&index=2&id=5fef7252&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fef7252",
  null
  
)

export default component.exports